const waitingRoomViewTranslations = {
    en: {
        waiting_room_header: 'You are now in the waiting room!',
        waiting_room_header_next: 'You are next!',
        waiting_room_subtitle_2: 'When it\'s your turn, you will be automatically redirected to the site to buy tickets.',
        waiting_room_subtitle_next: 'You will be redirected to the site in a few moments.',
        waiting_room_info_1_1: 'people',
        waiting_room_info_1: 'in front of you right now',
        waiting_room_info_2: 'estimated waiting time',
        waiting_room_calculating: 'Calculating...',
        waiting_room_footer: 'Thank you for your patience!',
        waiting_room_stopped_warning: 'The queue is paused.',
    },
    ro: {
        waiting_room_header: 'Ești acum în așteptare la coadă!',
        waiting_room_header_next: 'Este rândul tău!',
        waiting_room_subtitle_2: 'Când îți vine rândul, te vom redirecționa automat pentru a putea cumpăra bilete.',
        waiting_room_subtitle_next: 'Te vom redirecționa automat în câteva momente.',
        waiting_room_info_1_1: 'persoane',
        waiting_room_info_1: 'în fața ta în acest moment',
        waiting_room_info_2: 'timp estimat de așteptare',
        waiting_room_calculating: 'Se calculează...',
        waiting_room_footer: 'Îți mulțumim pentru răbdare!',
        waiting_room_stopped_warning: 'Coada este pusă pe pauză.',
    },
    bg: {
        waiting_room_header: 'В момента сте в изчакване!',
        waiting_room_header_next: 'Вие сте следващият!',
        waiting_room_subtitle_2: 'Когато дойде ваш ред, ще бъдете автоматично пренасочени към сайта за закупуване на билети.',
        waiting_room_subtitle_next: 'Ще бъдете пренасочени към сайта след моменти.',
        waiting_room_info_1_1: 'човека',
        waiting_room_info_1: 'пред вас в момента',
        waiting_room_info_2: 'оценено време за изчакване',
        waiting_room_calculating: 'Изчислява се...',
        waiting_room_footer: 'Благодарим ти за търпението!',
        waiting_room_stopped_warning: 'Опашката е поставена на пауза.',
    },
    hu: {
        waiting_room_header: 'Most épp várakozik!',
        waiting_room_header_next: 'Ön következik!',
        waiting_room_subtitle_2: 'Amikor Ön következik, automatikusan átirányítjuk az oldalra, ahol jegyeket vásárolhat.',
        waiting_room_subtitle_next: 'Néhány pillanat múlva átirányítjuk az oldalra.',
        waiting_room_info_1_1: 'ember',
        waiting_room_info_1: 'előtt Ön most',
        waiting_room_info_2: 'becsült várakozási idő',
        waiting_room_calculating: 'Számítás folyamatban...',
        waiting_room_footer: 'Köszönjük a türelmedet!',
        waiting_room_stopped_warning: 'A sor szüneteltetve van.',
    },
};

export default waitingRoomViewTranslations;
